import { compileFlow } from '../../simpleFlow/compileFlow';
export const ifSwitchAtom = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getEventPanelSubTitle(step) {
    // const branchLength = get(step, 'params.branches.length');
    // 条件分支不显示共xxx步骤文案
    return undefined;
    // 大于1才显示防止文本骚扰
    // if (!branchLength || branchLength < 2) return undefined;
    // return `共${branchLength}个条件分支`;
  },
  id: 'uicore:if',
  name: '条件分支',
  category: '逻辑',
  desc: '若条件表达式有错误，会跳过对应分支。',
  paramsSchema: {
    type: 'object',
    fields: [{
      id: 'branches',
      type: 'array',
      title: '  ',
      items: {
        type: 'object',
        fields: [{
          id: 'condition',
          type: 'string'
        }, {
          id: 'steps',
          type: 'array'
        }]
      },
      ui: {
        type: 'uicore:IfSwitchBranchList'
      },
      default: [{
        expanded: true,
        disabled: false,
        condition: '1 + 1 == 2',
        steps: []
      }],
      'uc:allowExpr': false,
      'uc:allowReset': false
    }, {
      id: 'elseStep',
      type: 'array',
      title: '',
      ui: {
        type: 'uicore:BranchElseEditor'
      },
      default: {
        enable: false,
        expanded: false,
        disabled: false,
        steps: []
      },
      condition: '(params.elseStep && params.elseStep.steps.length>0 )||(params.branches && params.branches.length>0)',
      'uc:allowExpr': false,
      'uc:allowReset': false
    }, {
      id: 'endOnFirstMatch',
      title: '最多执行一个if分支',
      type: 'boolean',
      default: true
    }, {
      id: 'flowStatePass',
      title: '将内部的flowState传递至外部',
      type: 'boolean',
      default: true,
      hidden: true
    }]
  },
  paramsFormComponents: [
    // 已经迁移到 designerComponents 里面去了
  ],
  validateParams(ctxBase, params) {
    for (let i = 0; i < params.branches.length; i++) {
      const branch = params.branches[i];
      for (let j = 0; j < branch.steps.length; j++) {
        const step = branch.steps[j];
        const atom = ctxBase.atoms[step.type];
        if (!atom) return `条件分支里存在无效的步骤类型：${step.type}`;
        const errors = atom.validateParams(ctxBase, step.params);
        if (errors) return errors;
      }
    }
  },
  execute: async (ctx, params) => {
    var _params$elseStep;
    // 收集每个flow返回的flowState
    let states = {};
    let executed = false;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < params.branches.length; i++) {
      const branch = params.branches[i];
      if (branch !== null && branch !== void 0 && branch.disabled) continue;
      if (!(branch !== null && branch !== void 0 && branch.condition) || !ctx.tryEval(branch.condition)) continue;
      const execute = compileFlow({
        steps: branch.steps
      }, ctx);
      const res = await execute(ctx);
      executed = true;
      states = {
        ...states,
        ...(res === null || res === void 0 ? void 0 : res.state)
      };
      if (params.endOnFirstMatch) break;
    }
    if (!executed && ((_params$elseStep = params.elseStep) === null || _params$elseStep === void 0 || (_params$elseStep = _params$elseStep.steps) === null || _params$elseStep === void 0 ? void 0 : _params$elseStep.length) > 0 && !params.elseStep.disabled && params.elseStep.enable) {
      // 没有命中任何if分支 执行else
      const execute = compileFlow({
        steps: params.elseStep.steps
      }, ctx);
      const res = await execute(ctx);
      states = {
        ...states,
        ...(res === null || res === void 0 ? void 0 : res.state)
      };
    }
    // 解构拍平进flowState
    Object.assign(ctx.state, states);
    return states;
  },
  *handleCollectDeps(ctx, step) {
    var _step$value$params;
    if (step.type !== 'eventFlowStep') return; // 这行其实没啥用，只是让TypeScript安静而已
    const branches = (_step$value$params = step.value.params) === null || _step$value$params === void 0 ? void 0 : _step$value$params.branches;
    if (!branches) return;
    for (let i = 0; i < branches.length; i++) {
      const branch = branches[i];
      const descriptionPrefix = `条件分支${i + 1}`;
      const placePrefix = ['params', 'branches', i];
      for (let j = 0; j < branch.steps.length; j++) {
        yield {
          type: 'eventFlowStep',
          description: `${descriptionPrefix}步骤${j + 1}`,
          place: [...placePrefix, 'steps', j]
        };
      }
    }
  }
};